import { z } from "zod";

import type { Voucher } from "@/types";

export type VoucherListItem = Voucher;

export const voucherListSortEnum = z.enum(["newest", "oldest"]);

export type VoucherListSortValue = z.infer<typeof voucherListSortEnum>;
